import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { MemberStatus, RoleType, } from '@tribeplatform/gql-client/types';
import { analyticsNumberFormatter, normalizeListData, } from '@tribeplatform/react-components/Analytics/utils';
import { T } from '@tribeplatform/react-components/i18n';
import { useAuthMember, useNetwork } from '@tribeplatform/react-sdk/hooks';
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar';
import { MAX_MEMBERS_COUNT } from './constants.js';
import { EmptyState } from './EmptyState.js';
export const LeaderboardList = ({ data, count, showScore, excludeStaff, }) => {
    const { data: authMember } = useAuthMember();
    const { data: { roles }, } = useNetwork();
    const [topMembers, setTopMembers] = useState([]);
    const isAdmin = useCallback((roleId) => {
        var _a;
        const roleType = (_a = roles === null || roles === void 0 ? void 0 : roles.find(role => roleId === role.id)) === null || _a === void 0 ? void 0 : _a.type;
        return roleType === RoleType.admin || roleType === RoleType.moderator;
    }, [roles]);
    useEffect(() => {
        if (data.length) {
            const normalizedData = normalizeListData(data[0]);
            const topMembers = normalizedData.map(record => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                return {
                    id: (_b = (_a = record === null || record === void 0 ? void 0 : record.entities) === null || _a === void 0 ? void 0 : _a.person) === null || _b === void 0 ? void 0 : _b.id,
                    profilePicture: (_d = (_c = record === null || record === void 0 ? void 0 : record.entities) === null || _c === void 0 ? void 0 : _c.person) === null || _d === void 0 ? void 0 : _d.profilePicture,
                    name: (_f = (_e = record === null || record === void 0 ? void 0 : record.entities) === null || _e === void 0 ? void 0 : _e.person) === null || _f === void 0 ? void 0 : _f.name,
                    score: +((_g = record === null || record === void 0 ? void 0 : record.payload) === null || _g === void 0 ? void 0 : _g.score),
                    member: (_h = record === null || record === void 0 ? void 0 : record.entities) === null || _h === void 0 ? void 0 : _h.person,
                };
            });
            const topActiveMembers = topMembers
                .filter(({ member }) => (member === null || member === void 0 ? void 0 : member.status) === MemberStatus.VERIFIED &&
                !(excludeStaff && isAdmin(member === null || member === void 0 ? void 0 : member.roleId)))
                .slice(0, Math.min(MAX_MEMBERS_COUNT, count));
            if (!(topActiveMembers === null || topActiveMembers === void 0 ? void 0 : topActiveMembers.find(({ member }) => (member === null || member === void 0 ? void 0 : member.id) === (authMember === null || authMember === void 0 ? void 0 : authMember.id)))) {
                const loggedInMember = topMembers.find(({ member }) => (member === null || member === void 0 ? void 0 : member.id) === (authMember === null || authMember === void 0 ? void 0 : authMember.id));
                if (loggedInMember && !(excludeStaff && isAdmin(authMember === null || authMember === void 0 ? void 0 : authMember.roleId))) {
                    topActiveMembers.push(loggedInMember);
                }
            }
            setTopMembers(topActiveMembers);
        }
    }, [authMember === null || authMember === void 0 ? void 0 : authMember.id, authMember === null || authMember === void 0 ? void 0 : authMember.roleId, count, data, excludeStaff, isAdmin]);
    if (!topMembers.length) {
        return React.createElement(EmptyState, null);
    }
    return (React.createElement("div", { className: "grid grid-cols-1 gap-1 -ms-2 -me-2" }, topMembers.map(({ id, name, profilePicture, score, member }, index) => {
        var _a, _b;
        if (!id) {
            return null;
        }
        return (React.createElement(Link, { key: id, to: member === null || member === void 0 ? void 0 : member.relativeUrl, className: "group flex space-s-3 items-center p-2 rounded-md hover:bg-surface-hovered" },
            React.createElement("div", { className: "text-lg font-medium w-5 text-center flex-shrink-0 whitespace-nowrap" }, id === (authMember === null || authMember === void 0 ? void 0 : authMember.id) && index === topMembers.length - 1
                ? '-'
                : index + 1),
            React.createElement(Avatar, { size: "md", src: (_b = (_a = profilePicture) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.thumb, name: name }),
            React.createElement("div", { className: "flex-1 text-content truncate", title: name },
                name,
                id === (authMember === null || authMember === void 0 ? void 0 : authMember.id) && (React.createElement("span", { className: "text-xs text-content-subdued px-1.5" },
                    React.createElement(T, { id: "Generics.YouInParens", defaultMessage: "(You)" })))),
            showScore && (React.createElement("div", { className: "px-1 text-content-subdued" }, analyticsNumberFormatter(score)))));
    })));
};
//# sourceMappingURL=LeaderboardList.js.map